var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"detail-model",style:(`
  background-color: ${_vm.dataSource.background};
  height: ${_vm.$px2rem(_vm.dataSource.height)}
`)},_vm._l((_vm.dataSource.images),function(item,index){return _c('div',{key:index,style:(`
        width: ${_vm.$px2rem(1200)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
      `)},[(!item.isbg && typeof item.url === 'string')?_c('LazyImg',{attrs:{"className":"img","styles":`
        width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
        top: ${_vm.$px2rem(item.top)};
      `,"src":item.url}}):_vm._e(),_vm._v(" "),(item.isbg)?_c('img',{staticClass:"img img-bg",style:(`
        width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
        top: ${_vm.$px2rem(item.top)};
        transform: translateX(${_vm.$px2rem(item.moveX)});
      `),attrs:{"src":item.url}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }